import(/* webpackMode: "eager" */ "/usr/src/app/kontakt/page.js");
